import { render, staticRenderFns } from "./PricesetRuleDia.vue?vue&type=template&id=6fbca8d4&scoped=true"
import script from "./PricesetRuleDia.vue?vue&type=script&lang=js"
export * from "./PricesetRuleDia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbca8d4",
  null
  
)

export default component.exports